// extracted by mini-css-extract-plugin
export default {"FormCreateCourseRestart":"FormCreateCourseRestart_FormCreateCourseRestart__ZRwLO","growth":"FormCreateCourseRestart_growth__8Szhd"};